import { fg } from '@atlassian/jira-feature-gating';
import { performGetRequest } from '@atlassian/jira-fetch/src/utils/requests.tsx';
import type { RouterDataContext } from '@atlassian/react-resource-router';
import type { IncidentExperimentTraitsResourceData } from '../types.tsx';

type SiteUserTraits = Record<string, unknown>;

const fetchSiteUserPersonalization = () =>
	performGetRequest<SiteUserTraits>('/rest/incidents/tap/site-user-traits');

// exported for testing
export const checkForIncidentTargetingCohorts = async (environment: string | null) => {
	const JIRA_SOFTWARE_IS_INCIDENTS_AUDIENCE_COHORT_1 =
		environment === 'prod'
			? 'segment_1680cb73-5c78-4932-8e89-2e8e982c74e5_siteuser'
			: 'segment_97aabc97-1b14-49b9-afa5-a8501c704029_siteuser';

	const JIRA_SOFTWARE_IS_INCIDENTS_AUDIENCE_COHORT_2 =
		environment === 'prod'
			? 'segment_05b92485-f868-4f1e-b168-ca5a9d5a4e84_siteuser'
			: 'segment_fbfbdefc-2e71-4597-9f21-b3133a7da2fb_siteuser';
	const personalizationData = await fetchSiteUserPersonalization();

	if (fg('operandi-incidents-in-jira-skip-targeting')) {
		return { cohort1: true, cohort2: true };
	}

	if (!personalizationData) {
		return { cohort1: false, cohort2: false };
	}

	const isUserInAudience = {
		cohort1: personalizationData[JIRA_SOFTWARE_IS_INCIDENTS_AUDIENCE_COHORT_1] === true,
		cohort2: personalizationData[JIRA_SOFTWARE_IS_INCIDENTS_AUDIENCE_COHORT_2] === true,
	};

	return isUserInAudience;
};

// eslint-disable-next-line jira/import/no-anonymous-default-export
export default async (
	_route: RouterDataContext,
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	{ tenantContext: { environment } }: any,
): Promise<IncidentExperimentTraitsResourceData> => checkForIncidentTargetingCohorts(environment);
